import Model from './Model'
import {toFormData} from '@utils'
import {uuid} from "../utils";
import moment from "moment";

export default class Equipment extends Model {
    get location() {
        return this.in_use ? this.in_use_by : 'In Warehouse'
    }

    getFormAttributes() {
        const attributes = this.except(['supplier_name', 'logs', 'usages', 'qr_url', 'created_by'])
        attributes.supplier_id = {value: this.supplier_id, label: this.supplier_name}
        return attributes
    }

    setAttributes(attributes) {
        super.setAttributes(attributes)
        let tokens = [
            this.name,
            this.reference,
            this.inUseBy,
        ]
        this.tokens = tokens.join('|').toLowerCase();
        this.inspections.map((i) => {
            i.formattedDate = moment(i.date).format('DD/MM/YYYY')
            i.isLast = false;
        })
        if (this.inspections.length) {
            this.inspections[this.inspections.length - 1].isLast = true;
        }
    }

    static parseAttributes(attributes) {
        return this.parseDropdownAttributes(attributes, ['supplier_id']);
    }

    static async all() {
        const data = await Http.get(route('api.v2.logistics.equipment.list'))
        return this.make(data)
    }

    static async byPackageReference(packageReference) {
        const data = await Http.get(route('api.v2.logistics.equipment.list')+'?packageReference='+packageReference)
        return this.make(data)
    }

    static async find(id) {
        const data = await Http.get(route('api.v2.logistics.equipment', id))
        return this.make(data)
    }

    static async create(attributes) {
        let id = uuid();
        const url = route('api.v2.logistics.equipment.create', id)
        const payload = this.parseAttributes(attributes)
        await Http.post(url, toFormData(payload)).catch(error => {
            if (error.status !== 200) {
                throw new Error(error.response.data.message)
            }
        });
        const data = await Http.get(route('api.v2.logistics.equipment', id))
        return this.make(data)
    }

    async update(attributes = {}) {
        const url = route('api.v2.logistics.equipment.store', this.id)
        const payload = this.constructor.parseAttributes({...this.getFormAttributes(), ...attributes})
        await Http.put(url, toFormData(payload)).catch(error => {
            if (error.status !== 200) {
                throw new Error(error.response.data.message)
            }
        });
        const data = await Http.get(route('api.v2.logistics.equipment', this.id))
        return this.fill(data)
    }

    async delete() {
        await Http.delete(route('api.v2.logistics.equipment.delete', this.id))
    }

    async addUsage(attributes) {
        const url = route('api.v2.logistics.equipment.usages.store', this.id)

        attributes.packageReference = attributes.package?.reference
        delete (attributes.package)
        if (attributes.contact?.value) {
            attributes.contact = attributes.contact.label
        }

        await Http.post(url, attributes).catch(error => {
            if (error.status !== 200) {
                throw new Error(error.response.data.message)
            }
        });
        const data = await Http.get(route('api.v2.logistics.equipment', this.id))
        return this.fill(data)
    }

    async addLog(attributes) {
        const url = route('api.v2.logistics.equipment.inspection.store', this.id)

        if (attributes.carried_out_by?.value) {
            attributes.carriedOutBy = attributes.carried_out_by.label
            delete (attributes.carried_out_by)
        }

        await Http.post(url, attributes).catch(error => {
            if (error.status !== 200) {
                throw new Error(error.response.data.message)
            }
        });
        const data = await Http.get(route('api.v2.logistics.equipment', this.id))
        return this.fill(data)
    }

    async deleteInspection(id) {
        await Http.delete(route('api.v2.logistics.equipment.inspection.delete', {id: this.id, inspection_id: id}))
        const data = await Http.get(route('api.v2.logistics.equipment', this.id))
        return this.fill(data)
    }

}
